import { Box, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import OrderCard from "./components/OrderCard/OrderCard";
import { useOrders } from "../../../../services/orders/orders.service";
import { Loading } from "../../../../components";
import Note from "./components/Note/Note";
import NoOrders from "./components/NoOrders/NoOrders";
import Urls from "./components/Urls/Urls";
import { useInfiniteScroll } from "../../../../hooks/useInfiniteScroll";

interface OrdersContentProps {
  shopUrl: string;
}

const OrdersContent = ({ shopUrl }: OrdersContentProps) => {
  const { executeGetOrders, loadMore, data, loading, hasMore, hasInitiallyFetched } = useOrders();
  const sentinelRef = useInfiniteScroll({
    onLoadMore: loadMore,
    hasMore,
    isLoading: loading,
  });

  useEffect(() => {
    executeGetOrders();
  }, [executeGetOrders]);

  const { ordersUrl, subscriptionsUrl, orders } = data;

  // Show loading spinner on initial load (before first fetch completes)
  if (!hasInitiallyFetched && orders.length === 0) {
    return (
      <Box className="w-full flex justify-center items-center min-h-[400px]">
        <Loading />
      </Box>
    );
  }

  return (
    <Box className="flex flex-col gap-6">
      <Note />
      <Box className="flex flex-col gap-6">
        {orders.length > 0 ? (
          <>
            <Urls ordersUrl={ordersUrl} subscriptionsUrl={subscriptionsUrl} shopUrl={shopUrl} />
            {orders.map((order) => (
              <OrderCard key={order.id} order={order} shopUrl={shopUrl} />
            ))}
            {loading && orders.length > 0 && (
              <Box className="flex justify-center mt-4">
                <CircularProgress size={32} />
              </Box>
            )}
            {hasMore && <Box ref={sentinelRef} sx={{ height: "1px", width: "100%" }} />}
          </>
        ) : (
          <NoOrders shopUrl={shopUrl} />
        )}
      </Box>
    </Box>
  );
};

export default OrdersContent;
